import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import Image from '@base/Image';
import PropTypes from 'prop-types';
import useDarkModeStatus from '@stores/useDarkModeStatus';
import { getIsDarkModeOn } from '@stores/selectors/darkModeStatusSelectors';

const InfoRow = styled.div`
  display: flex;
  margin-bottom: ${Spacings.SPACING_3B};
  width: 100%;
  :last-child {
    margin-bottom: ${Spacings.SPACING_0B};
  }
`;

const IconWrap = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: ${Spacings.SPACING_2B};
`;

const StyledP1 = styled(P1)`
  width: inherit;
  ${mediaQuery.uptoTablet} {
    font-size: ${Fonts.P2};
    line-height: ${Spacings.SPACING_5B};
  }
`;

const BatchGroupCardInfo = ({
  batch,
  showDifferentIconOnDarkMode,
  height,
  width
}) => {
  const { batchGroupMetaInfo } = batch;
  return (
    <BatchInfoList
      showDifferentIconOnDarkMode={showDifferentIconOnDarkMode}
      batchGroupInfo={batchGroupMetaInfo}
      height={height}
      width={width}
    />
  );
};

const BatchInfoList = ({
  batchGroupInfo,
  showDifferentIconOnDarkMode,
  height,
  width
}) => {
  const isDarkModeOn = useDarkModeStatus(getIsDarkModeOn);
  if (!batchGroupInfo?.length) return null;
  return batchGroupInfo.map((info) => {
    const darkModeIcon = info?.darkmode_icon || info?.darkmodeIcon;
    const infoIcon =
      isDarkModeOn && showDifferentIconOnDarkMode ? darkModeIcon : info?.icon;
    return (
      <InfoRow key={info?.text}>
        {infoIcon && (
          <IconWrap>
            <Image height={height} width={width} alt="icon" src={infoIcon} />
          </IconWrap>
        )}
        {info?.text && <StyledP1>{info.text}</StyledP1>}
      </InfoRow>
    );
  });
};

BatchGroupCardInfo.propTypes = {
  batch: PropTypes.objectOf(PropTypes.any).isRequired,
  showDifferentIconOnDarkMode: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number
};

BatchGroupCardInfo.defaultProps = {
  showDifferentIconOnDarkMode: false,
  height: 20,
  width: 20
};

export default BatchGroupCardInfo;
